import { RecipeImage } from '@library/menu-service'

export const getMoodImage = (images: RecipeImage[]): RecipeImage['crops'] => {
  const defaultImageCrops = images?.[0]?.crops || []
  const moodImageCrops = images?.find((image) => image.type === 'mood-image')?.crops

  return moodImageCrops || defaultImageCrops
}

export const getDefaultImage = (srcs: RecipeImage['crops']) => {
  const sortedSrcs = srcs.slice().sort((a, b) => b.width - a.width)
  const midpointInArray = Math.floor(sortedSrcs.length / 2)

  return sortedSrcs[midpointInArray]?.url || ''
}

export const getSrcSet = (srcs: RecipeImage['crops']): string => {
  return srcs.map(({ url, width }) => `${url} ${width}w`).join()
}
